<template>
  <div class="new-address">
    <div class="header-new address">
      <div class="back-btn new address">
        <img src="../assets/images/backarrow.svg" @click="goBack()" />
       </div>
      <h2>{{ $t("add_newaddress") }}</h2>
    </div>
    <div class="delivery-dtl-form">
      <h4 class="delivery-address">{{ $t("specify_deliveryaddress") }}?</h4>
      <form class="form-dtl">
        <div class="form-grp">
          <label class="address-pin">
            {{ $t("fullname") }}
            <abbr>*</abbr> :
          </label>
          <input
            class="textarea"
            :placeholder="$t('fullname')"
            required="required"
            v-model="useraddress.customer_name"
          />
        </div>
        <div class="form-grp">
          <label class="address-pin">
            {{ $t("pincode") }}
            <abbr>*</abbr> :
          </label>
          <input
            type="number"
            class="form-feild"
            placeholder="6 अंकीय [0- 9] पिनकोड"
            required="required"
            v-model="useraddress.pincode"
          />
        </div>
        <div class="form-grp">
          <label class="address-pin">
            {{ $t("city") }}
            <abbr>*</abbr> :
          </label>
          <input
            class="form-feild"
            placeholder
            required="required"
            v-model="useraddress.city"
          />
        </div>
        <div class="form-grp">
          <label class="address-pin">
            {{ $t("state") }}
            <abbr>*</abbr> :
          </label>
          <input
            class="textarea"
            placeholder
            required="required"
            v-model="useraddress.state"
          />
        </div>
        <div class="form-grp">
          <label class="address-pin">
            {{ $t("house_no") }}
            <abbr>*</abbr> :
          </label>
          <input
            class="form-feild"
            :placeholder="$t('house_no')"
            required="required"
            v-model="useraddress.house_no"
          />
        </div>
        <div class="form-grp">
          <label class="address-pin">
            {{ $t("mobile_no") }}
            <abbr>*</abbr> :
          </label>
          <input
            type="number"
            class="textarea"
            :placeholder="$t('digit_mobile_no')"
            required="required"
            v-model="useraddress.phone_number"
          />
        </div>

        <div class="form-grp">
          <label class="address-pin">
            {{ $t("street") }}
            <abbr>*</abbr> :
          </label>
          <textarea
            :placeholder="$t('street')"
            required="required"
            class="form-control cstm_field cstm_ta"
            v-model="useraddress.street"
          />
        </div>
        <div class="form-grp">
          <label class="address-pin">
            {{ $t("landmark") }}
            <abbr>*</abbr> :
          </label>
          <input
            class="textarea"
            :placeholder="$t('landmark_location')"
            required="required"
            v-model="useraddress.landmark"
          />
        </div>
      </form>
      <Button
        class="button"
        @saveNewAdd="saveAddress"
        :btn_txt="$t('save_address')"
      ></Button>
    </div>
  </div>
</template>
<script>
import Button from "../components/Button";
import types from "../store/types";
import { mapGetters } from "vuex";
import { toaster, validateAddressForm } from "../utils/helper";
import {
  isPinCodeNumber,
  isCity,
  isState,
  isLandmark,
  isName,
  isMobileNumber
} from "../utils/validators";
export default {
  name: "AddNewAddress",
  components: {
    Button
  },
  data() {
    return {
      useraddress: {
        phone_number: "",
        customer_name: "",
        pincode: "",
        city: "",
        state: "",
        landmark: "",
        street: "",
        house_no: ""
      }
    };
  },
  computed: {
    ...mapGetters(["addresses"])
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    saveAddress() {
      const isValid = validateAddressForm(this);
      if (isValid) {
        this.$store
          .dispatch({ type: "createNewAddress", payload: this.useraddress })
          .then(data => {
            this.$router.go(-1);
          })
          .catch(err => {
            toaster(this, this.$t("somethingwentwrong"), "top-left", 3000);
          });
      }
    }
  }
};
</script>
